import { FunctionComponent } from 'react';
import ExternalLink from './ExternalLink';
import InternalLink from './InternalLink';
import type { ImageLinkCollectionEntry } from '../../graphql/pimcore/modules/siteContent/types/SiteContentElement';

interface ImageLinkProps {
    link: ImageLinkCollectionEntry;
    /** CSS classes to apply to the <img> element. */
    className?: string;
}

const ImageLink: FunctionComponent<ImageLinkProps> = ({ link, className }) => {
    const altText = link.imageAltText ?? '';
    const title = link.tooltip ?? undefined;
    const imageElement = <img src={link.imageUrl} alt={altText} className={className} />;

    switch (link.kind) {
        case 'externalImageLinkFieldCollection':
            return (
                <ExternalLink url={link.linkUrl} title={title}>
                    {imageElement}
                </ExternalLink>
            );

        case 'internalImageLinkFieldCollection':
            return (
                <InternalLink route={link.linkRoute} title={title}>
                    {imageElement}
                </InternalLink>
            );

        default:
            return null;
    }
};

export default ImageLink;
